var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon35(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "point3icon3-5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.447,
    height: 94.243,
    viewBox: "0 0 77.447 94.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_124",
    "data-name": "\\u9577\\u65B9\\u5F62 124",
    width: 77.447,
    height: 94.243,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_91",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 91",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_126",
    "data-name": "\\u30D1\\u30B9 126",
    d: "M57.074,75.805c0,3.718.061,7.145-.016,10.569a8.137,8.137,0,0,1-16.044,1.638,13.5,13.5,0,0,1-.2-2.926c-.024-2.993-.008-5.987-.008-9.107H36.738c0,.686.012,1.39,0,2.094-.063,3.124.088,6.273-.258,9.365a7.821,7.821,0,0,1-7.916,6.783,7.921,7.921,0,0,1-7.972-6.738,52.453,52.453,0,0,1-.25-6.418c-.034-1.648-.007-3.3-.007-5.233-2.535.165-5.2.145-6.522-2.113-1.142-1.957-1.508-4.366-2.12-6.274a26.365,26.365,0,0,1-5.551-.069,7.746,7.746,0,0,1-6.127-7.9q-.031-10.951,0-21.9c.012-6.208,5.3-9.953,11.211-7.964.23.077.46.152.942.312A27.081,27.081,0,0,1,24.121,8.915L19.768,2.366,23.077.051l4.341,6.356c3.9-.64,7.6-1.71,11.3-1.724,3.651-.014,7.307,1.043,11.272,1.68L54.31,0l3.366,2.26L53.294,8.845C60.608,14,64.6,20.981,65.223,29.481c2.059-.077,4.1-.507,5.986-.15,3.8.719,6.156,3.849,6.187,7.824.058,7.423.076,14.846,0,22.269-.059,6.058-5.293,9.671-11.057,7.749l-.555-.184c-.666,2.271-.952,4.678-2.052,6.625-1.3,2.3-3.937,2.416-6.66,2.191M24.432,71.779v2.159c0,3.8-.022,7.6.008,11.4.024,2.943,1.708,4.854,4.158,4.812,2.4-.041,4-1.879,4.028-4.752.039-3.862.005-7.725.015-11.587,0-.643.068-1.287.1-1.882H44.895c0,4.684-.014,9.215.006,13.747.011,2.654,1.7,4.493,4.052,4.473,2.366-.021,4.02-1.843,4.056-4.523.028-2.084.006-4.169.006-6.253v-7.6c1.826,0,3.41,0,4.994,0,2.619-.006,3.124-.5,3.125-3.087q0-16.922,0-33.843c0-.532-.059-1.064-.088-1.575H16.322c0,2.241,0,4.321,0,6.4Q16.3,54.2,16.276,68.735c0,2.433.617,3.034,3.026,3.043,1.641.006,3.281,0,5.131,0M16.684,28.95H60.9C60.62,17.734,49.509,8.03,37.809,8.7,26.4,9.349,15.864,19.395,16.684,28.95m-4.519,19.5c0-3.675.013-7.349,0-11.024a4,4,0,0,0-3.984-4.308,4.044,4.044,0,0,0-4.094,4.253q-.054,11.024,0,22.047a4.047,4.047,0,1,0,8.077-.129c.015-3.613,0-7.226,0-10.84m61.161-.074c0-3.613.018-7.225-.006-10.838-.018-2.673-1.678-4.448-4.068-4.42a4.018,4.018,0,0,0-4.01,4.329q-.05,10.93,0,21.859a4.063,4.063,0,0,0,4.011,4.349c2.352.032,4.049-1.792,4.067-4.443.024-3.612.006-7.225.006-10.838",
    transform: "translate(0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_122",
    "data-name": "\\u9577\\u65B9\\u5F62 122",
    width: 3.844,
    height: 3.826,
    transform: "translate(26.603 18.93)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_123",
    "data-name": "\\u9577\\u65B9\\u5F62 123",
    width: 3.792,
    height: 3.884,
    transform: "translate(46.964 18.84)",
    fill: "#5f7cae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon35);
export default __webpack_public_path__ + "static/media/point3icon3-5.86fc4114da38b731255c82d6a3d23695.svg";
export { ForwardRef as ReactComponent };